import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { normalizePath } from "../../shared/website-seo.mjs";
import { App } from "./ui/App";
import "./ui/styles.css";

const container = document.getElementById("root")!;
const prerenderedPath = container.dataset.prerenderedPath;
const currentPath = normalizePath(location.pathname);
// Always the address in the bar, never the address the file was rendered for. Seeding the app with
// the prerendered path meant a fallback document made the first client render the home page -- so
// opening a sign-in link painted marketing copy for a frame before the portal replaced it. In the
// hydrating branch the two paths are equal anyway, so hydration still matches.
const tree = <StrictMode><App initialPath={currentPath} /></StrictMode>;

// Every public route ships its own prerendered file, so the markup usually already matches. The
// exception is the account portal and any unmatched address, which are served the home page's
// document as a fallback -- there the prerendered body is the wrong page and is thrown away.
if (prerenderedPath === currentPath && container.firstChild) {
  hydrateRoot(container, tree);
} else {
  container.replaceChildren();
  createRoot(container).render(tree);
}
